/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { HStack, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { type FC } from 'react';
import { type Frame, type Request } from '../../interface/Crash';
import { DetailsElement } from '../detailsDrawer/DetailsElement';
import { RequestBodyView } from './RequestBodyView';
import { RequestCookieView } from './RequestCookieView';
import { RequestHeaderView } from './RequestHeaderView';
import { ResponseBodyView } from './ResponseBodyView';
import { ResponseCookieView } from './ResponseCookieView';
import { ResponseHeaderView } from './ResponseHeaderView';
import { CallstackView } from './CallstackView';
import { Code } from '../Code';
import { type RequestMethod, RequestMethodTag, RequestStatusTag, RequestTypeTag } from '../RequestTags';

export const RequestDetail: FC<{
    request: Request;
    callstack?: Frame[];
    reportKind: 'crash' | 'protocol';
    reportId: string;
    requestId: number;
    fileVersion?: string;
    lineNumber?: number;
}> = ({ request, callstack, reportKind, reportId, requestId, fileVersion, lineNumber }) => {
    const defaultIndex = callstack ? 6 : 5;

    return (
        <>
            <DetailsElement label="Request Details">
                <HStack gap={2} mb={2}>
                    <RequestTypeTag value={request.type} />
                    <RequestMethodTag value={request.method as RequestMethod} />
                    <RequestStatusTag value={request.response?.code ?? ''} />
                </HStack>
                <Code wrapWhiteSpace={true} textToCopy={request.url}>
                    {request.url}
                </Code>
            </DetailsElement>
            <Tabs defaultIndex={defaultIndex} pt={25}>
                <TabList>
                    <Tab>Request Headers</Tab>
                    <Tab>Request Cookies</Tab>
                    <Tab>Request Body</Tab>
                    <Tab>Response Headers</Tab>
                    <Tab>Response Cookies</Tab>
                    <Tab>Response Body</Tab>
                    {callstack && <Tab>Callstack</Tab>}
                </TabList>

                <TabPanels>
                    <TabPanel>
                        <RequestHeaderView request={request} />
                    </TabPanel>
                    <TabPanel>
                        <RequestCookieView request={request} />
                    </TabPanel>
                    <TabPanel>
                        <RequestBodyView request={request} />
                    </TabPanel>
                    <TabPanel>
                        <ResponseHeaderView request={request} />
                    </TabPanel>
                    <TabPanel>
                        <ResponseCookieView request={request} />
                    </TabPanel>
                    <TabPanel>
                        <ResponseBodyView
                            request={request}
                            reportKind={reportKind}
                            reportId={reportId}
                            requestId={requestId}
                        />
                    </TabPanel>
                    {callstack && (
                        <TabPanel>
                            <CallstackView callstack={callstack} fileVersion={fileVersion} lineNumber={lineNumber} />
                        </TabPanel>
                    )}
                </TabPanels>
            </Tabs>
        </>
    );
};
